exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "input[type=file][data-v-7d075b73]{position:absolute;left:-99999px}input[type=color][data-v-7d075b73]{width:80px;height:40px;margin-right:20px;margin-top:10px}.uploadFile[data-v-7d075b73]{cursor:pointer;width:250px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Appearance/landing.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,aAAe,CAChB,AACD,mCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,eAAiB,CAClB,AACD,6BACE,eAAgB,AAChB,WAAa,CACd","file":"landing.vue","sourcesContent":["\ninput[type=file][data-v-7d075b73] {\n  position: absolute;\n  left: -99999px;\n}\ninput[type=color][data-v-7d075b73] {\n  width: 80px;\n  height: 40px;\n  margin-right: 20px;\n  margin-top: 10px;\n}\n.uploadFile[data-v-7d075b73] {\n  cursor: pointer;\n  width: 250px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d075b73","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/Appearance/landing.vue
// module id = 1165
// module chunks = 2 9